/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiARewindForwardIcon16Regular = forwardRef('MediaUiARewindForwardIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.599 2.998A1.35 1.35 0 0 0 .5 4.12v7.758a1.35 1.35 0 0 0 2.099 1.123L7.5 9.735v2.144a1.35 1.35 0 0 0 2.099 1.123l5.756-3.837a1.4 1.4 0 0 0 0-2.33L9.599 2.998A1.35 1.35 0 0 0 7.5 4.12v2.144L2.599 2.998ZM2 11.598V4.402L7.398 8 2 11.599Zm7 0V4.402L14.398 8 9 11.599Z" })));
});
